<template>
  <!-- 图片+导航组组件库 -->
  <div class="picturenavgroup">
    <div v-if="!isShow" :class="{ mask: !isShow }">已隐藏</div>
    <!-- 组件库左侧名称 -->
    <slot name="name" />
    <!-- 一行一个 -->
    <div class="type0">
      <div class="imgLis">
        <!-- 图片 -->
        <img
          class="backgroundImage"
          :src="datas.bgImg"
          draggable="false"
          :style="{ height: datas.imageHeight + 'px' }"
        />
        <section
          class="defaultNavigation"
          v-if="!datas.imageList[0]"
          :style="{
            background: datas.backgroundColor,
            display: datas.imgStyle === 0 ? 'flex' : '-webkit-box',
            'overflow-x': datas.imgStyle === 0 ? '' : 'scroll',
          }"
        >
          <!-- 导航 -->
          <div
            class="navigationList"
            v-for="index in 5"
            :key="index"
            :style="{
              width:
                datas.imgStyle === 0 ? 'auto' : 375 / datas.showSize - 1 + 'px',
            }"
            @click="
              handleNavigationClick({ index, text: '导航', type: 'default' })
            "
          >
            <!-- 图片 -->
            <img
              src="@/assets/images/imgs.png"
              alt="默认图片"
              v-show="datas.navigationType === 0"
              draggable="false"
              :style="{ 'border-radius': datas.borderRadius + '%' }"
            />
            <!-- 文字 -->
            <p :style="{ color: datas.textColor }">导航111</p>
          </div>
        </section>
        <!-- 导航列表 -->
        <section
          class="defaultNavigation"
          v-else
          :style="{
            borderRadius: datas.borderRadius + 'px',
            background: datas.backgroundColor,
            display: datas.imgStyle === 0 ? 'flex' : '-webkit-box',
            'flex-wrap': datas.imgStyle === 0 ? 'wrap' : 'nowrap',
            'justify-content':
              datas.imgStyle === 0 ? 'space-evenly' : 'space-around',
            'overflow-x': datas.imgStyle === 0 ? '' : 'scroll',
          }"
        >
          <!-- 导航 -->
          <div
            class="navigationList"
            v-for="(item, index) in datas.imageList"
            :key="index"
            :style="{
              width:
                datas.imgStyle === 0 ? '20%' : 375 / datas.showSize - 1 + 'px',
            }"
            @click="handleNavigationClick({ index, item, type: 'custom' })"
          >
            <!-- 图片 -->
            <img
              :src="item.src"
              alt="默认图片"
              v-show="datas.navigationType === 0"
              draggable="false"
              :style="{ 'border-radius': datas.borderRadius + '%' }"
            />
            <!-- 文字 -->
            <p
              :style="{
                color: datas.textColor,
                'font-size': datas.textSize + 'px',
                height: datas.textHeight + 'px',
                'line-height': datas.textHeight + 'px',
              }"
            >
              {{ item.text }}
            </p>
          </div>
        </section>
        <!-- <div
          style="
            margin-left: 10px;
            margin-right: 10px;
            margin-top: -30px;
            position: relative;
            color: #fff;
          "
        >
        </div> -->

        <!-- <div class="title" style="border: 3px solid red">这里是预览内容</div> -->
      </div>
      <!-- 定位的图片标题 -->
      <p
        class="title"
        :style="{
          top: datas.pictureTitleTop + 'px',
          left: datas.pictureTitleLeft + 'px',
          color: datas.pictureTitleColor,
          fontSize: datas.pictureTitleSize + 'px',
          fontWeight: datas.pictureTitleWeight,
          fontFamily: datas.fontFamily,
        }"
      >
        {{ datas.pictureTitle }}
      </p>
    </div>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css";

export default {
  name: "picturenavgroup",
  props: {
    datas: Object,
    isShow: Boolean,
  },
  data() {
    return {
      mySwiper: null,
    };
  },
  computed: {
    /* 类型切换 */
    swiperType() {
      console.log(this.datas.swiperType, "----------------轮播类型");
      this.addSwiper();
      return this.datas.swiperType;
    },
    /* 图片删除或者增加 */
    imageList() {
      this.addSwiper();
      console.log(this.datas.imageList.length, "-------轮播数量");
      return this.datas.imageList;
    },
    /* 分页器类型切换 */
    pagingType() {
      this.addSwiper();
      return this.datas.pagingType;
    },
    /* 一行个数 */
    rowindividual() {
      this.addSwiper();
      if (this.datas.swiperType === 1) {
        return 1;
      } else {
        return this.datas.rowindividual;
      }
    },
    /* 图片间距 */
    imageMargin() {
      this.addSwiper();
      if (this.datas.swiperType === 1) {
        return 0;
      } else {
        return this.datas.imageMargin;
      }
    },
  },
  watch: {
    pagingType() {},
    rowindividual() {},
    imageMargin() {},
  },
  created() {
    console.log("pictruenavgroup组件挂载了", this.datas);
  },
  methods: {
    // 处理导航项点击事件
    handleNavigationClick(params) {
      console.log("导航项点击了111111111111111111111111", params, params.item);
      // if (!this.$store.state.modules.templateData.tabBar.id)
      //   return this.$message.error("请先添加底部导航栏");
      // if (!params.item.linktype) {
      //   console.log("没有linktype", params, params.item.linktype);
      //   this.$message.error("请选择跳转方式");
      //   return;
      // } else if (params.item.linktype == 10) {
      //   console.log("导航项内部跳转被点击了:", params);
      //   //内部跳转
      //   if (params.item && params.item.http && params.item.http.internalLink) {
      //     this.$router.push({
      //       path: "/productOpenwecartAfter/admin/Edit",
      //       query: {
      //         pageId: params.item.http.internalLink,
      //       },
      //     });
      //   } else {
      //     this.$message.error("请选择跳转链接");
      //     return false;
      //   }
      // } else if (params.item.linktype == 11) {
      //   //外部跳转
      //   let url = params.item.http.externalLink.trim();
      //   if (!/^https?:\/\//.test(url)) url = "https://" + url;
      //   window.open(url, "_blank"); // 外部链接新窗口打开
      //   console.log("导航项被点击外部跳转了:", params, url);
      //   return false;
      // }
      // 触发自定义事件，通知父组件
      this.$emit("navigation-click", params);
    },
    /* 创建轮播对象 */
    addSwiper() {
      this.$nextTick(() => {
        if (this.datas.swiperType !== 0 && this.datas.imageList[0]) {
          if (this.mySwiper instanceof Array) {
            this.mySwiper.forEach((element) => {
              element.destroy();
            });
          } else if (this.mySwiper instanceof Object) {
            // 每次重新创建swiper前都要销毁之前存在的轮播   不然轮播会重复
            this.mySwiper.destroy();
          }

          let params = {
            loop: true,
            autoplay: true,
            pagination: {
              el: ".swiper-pagination",
              type: this.pagingType,
            },
          };

          if (this.datas.swiperType === 1 || this.datas.swiperType === 2) {
            params.slidesPerView = this.rowindividual;
            params.spaceBetween = this.imageMargin;
          } else if (this.datas.swiperType === 3) {
            params.slidesPerView = 1.3;
            params.centeredSlides = true;
          }

          this.mySwiper = new Swiper(".swiper-container", params);
        } else {
          if (this.mySwiper instanceof Array) {
            this.mySwiper.forEach((element) => {
              element.destroy();
            });
          }
          // 每次重新创建swiper前都要销毁之前存在的轮播   不然轮播会重复
          if (this.mySwiper instanceof Object) {
            this.mySwiper.destroy();
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.picturenavgroup {
  position: relative;
  .title {
    position: absolute;
  }
  /* 无图片 */
  .upload {
    background: #979797;
    width: 100%;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      font-size: 120px;
    }
  }

  /* 类型0 */
  .type0 {
    box-sizing: border-box;
    /* 图片列表 */
    .imgLis {
      width: 100%;
      position: relative;
      overflow: hidden;
      .backgroundImage {
        width: 100%;
        height: 100%;
      }
      &:last-child {
        margin: 0 !important;
      }
      /* 图片 */
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
      .title {
        height: 36px;
        width: 100%;
        background-color: rgba(51, 51, 51, 0.8);
        text-align: center;
        line-height: 36px;
        color: #fff;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      /* 默认导航 */
      .defaultNavigation {
        // overflow-x: scroll;
        margin-left: 10px;
        margin-right: 10px;
        margin-top: -20px;
        position: relative;
        justify-content: space-evenly;
        &::-webkit-scrollbar {
          height: 1px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #155bd4;
        }
        ::v-deep.el-collapse-item__header,
        ::v-deep.el-collapse-item__wrap {
          border-bottom: 0 !important;
        }
        /* 导航 */
        .navigationList {
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            margin-top: 5px;
            width: 35px;
            height: 35px;
          }
          p {
            font-size: 12px;
            margin-top: 5px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
            box-sizing: border-box;
          }
        }
      }
    }
  }

  /* 类型1 */
  .type1 {
    width: 100%;
    position: relative;
    .swiper-slide {
      width: 100%;
      height: 250px;
    }
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    .title {
      height: 36px;
      width: 100%;
      background-color: rgba(51, 51, 51, 0.8);
      text-align: center;
      line-height: 36px;
      color: #fff;
      position: absolute;
      bottom: 0;
      left: 0;
      text-align: left;
      box-sizing: border-box;
      padding: 0 5px;
    }
  }

  .type3 {
    width: 100%;
    height: 250px;
    align-items: center;
    .swiper-slide {
      height: 210px !important;
      text-align: center;
      font-size: 18px;
      background: #fff;
      box-shadow: rgba(173, 173, 173, 0.8) 0px 7px 24px 0px;
      border-radius: 12px;
      overflow: hidden;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      transition: 300ms;
      transform: scale(0.8);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .swiper-slide-active,
    .swiper-slide-duplicate-active {
      transform: scale(1);
    }
    .swiper-pagination {
      bottom: 0 !important;
    }
    .title {
      height: 36px;
      width: 100%;
      background-color: rgba(51, 51, 51, 0.8);
      text-align: center;
      line-height: 36px;
      color: #fff;
      position: absolute;
      bottom: 0;
      left: 0;
      text-align: left;
      box-sizing: border-box;
      padding: 0 5px;
    }
  }
  .type3H {
    height: 250px;
  }
  .swiper-container-horizontal > .swiper-pagination-progressbar {
    height: 2px;
  }
}
</style>
